// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { IEnvironment } from './environment.type';

export const environment: IEnvironment = {
  accountAppPath: '/account',
  adobeAutosearchUrl:
    'https://content.atomz.com/autocomplete/sp10/04/f8/c6/?query=',
  adobeBodyScript:
    'if(_satellite && _satellite.pageBottom) { _satellite.pageBottom();}',
  adobeHeaderScript:
    '//assets.adobedtm.com/a2ef59fba8e9/665180b57410/launch-8f6789c0235b.min.js',
  adobeMbox: 'target-global-mbox',
  adobeTargetDisabled: false,
  appTheme: 'white-background',
  baseRedirectBypass: true,
  bingSiteVerificationKey: '695C8D6126AB21D375502ECC658DADD5',
  cardinalScriptUrl:
    'https://songbirdstag.cardinalcommerce.com/cardinalcruise/v1/songbird.js',
  defaultCountry: 'us',
  defaultLanguage: 'en',
  defaultCurrency: 'USD',
  defaultTheme: 'assets/_themes.css',
  denaliUrl: 'https://tickets2.universalorlando.com',
  digitalDataAdblockerEnabled: false,
  digitalDataAngularVersion: '13.3.11',
  digitalDataAppVersion: '1.0',
  digitalDataDestination: 'UDX',
  digitalDataEnabled: true,
  digitalDataEnvironment: 'PROD',
  digitalDataFlashVersion: '1.0',
  digitalDataSegment: 'B2C',
  digitalDataSite: 'UDX',
  digitalDataTridionVersion: 'site9',
  diningReservationsAppPath: 'https://www.universalorlando.com/dining/',
  facebookLikeUrl: 'https://www.facebook.com/UniversalOrlandoResort/',
  fontCssUrl: 'assets/fonts/_fonts.css',
  iconCssUrl: 'assets/icons/_font-face.css',
  geo: {
    apiUrl: '/api/geo/location',
    service:
      'https://geo-location-prod.use.ucdp.net/GeoDirectoryServer-7.2.0/v1/ipinfo/',
    disabled: false,
    location: {
      akamai: false,
    },
    region: {
      primary: '',
    },
  },
  googleCalendarApiKey: '',
  googleSiteVerificationKey: 'ammiNOphmIzZZZCvL2SUchOTkKnjM1ydny4KqL_ERW4',
  globalNavigationEnabled: true,
  grecaptchaApiUrl: '//www.google.com/recaptcha/api.js',
  grecaptchaSiteKey: '6LfEHyYTAAAAAGZu9fnOAAkhJhB5_Ylz6VNNMQZe',
  grecaptchaEnabled: false,
  grecaptchaTestResponse: 'bc1f106a-adb7-45e8-b314-0a61febd5555',
  hmacKey: 'WOd9DF9xiF1Qj6zyO7Fayg5I7iA7XiQ31EAORzZpiOX4CjuCa8KSvN3T4eWeUzH8',
  layoutHeader: '_LayoutHeader.html',
  mobileServicesShowtimesEndpoint: '/web/api/minion/showtimes',
  mobileServicesVenueEndpoints: '/web/api/minion/venues',
  oauthBaseUrl: 'https://api.universalparks.com',
  oauthClientId: 'e7c945ba-eeec-4384-b03d-601650677987',
  oauthClientKeyID: 'L6sJ5hC5aP2iD0gX7yI1dV0lS7pX0hN1jK8mK8pK7lV2uE3hD8',
  oauthAppFlowPath: '/guestauth/app/token',
  oauthAppPasswordFlowPath: '/guestauth/user/token',
  oauthAppSourceId: '1002062',

  oidc: {
    enabled: true,
    client_id: 'f1fccd9c-9408-4c34-a425-4793742a4c47',
    client_secret: 'v6ikIdmNPsTFgnSCwf7b0LGqRDyHhaV4xt3rMKczp18OoXJAje',
    base_url: 'https://api.universalparks.com',
    node_api_base_url: '/account/api/oidc',
    redirect_enabled: true,
    redirect_url: '/oidc/connect/authorize',
    end_session: '/oidc/connect/endsession',
    app_flow_path: '/oidc/connect/token',
    password_flow_path: '/oidc/connect/token',
    refresh_expires_in_seconds: 86400,
  },
  oneTrustDomainScript: '',
  oneTrustEnabled: false,
  oneTrustModalScript: '',
  oneTrustHash:
    'sha384-TKdmlzVmoD70HzftTw4WtOzIBL5mNx8mXSRzEvwrWjpIJ7FZ/EuX758yMDWXtRUN',
  oneTrustCrossorigin: 'anonymous',
  oneTrustPrivacyScript: '',
  oneTrustPrivacyIds: 'dummy',
  oneTrustPrivacyGeo: 'US',
  oneTrustPrivacyLSPA: 'false',
  coveo: {
    enabled: true,
    scriptSearchUrl:
      'https://static.cloud.coveo.com/searchui/v2.10094/3/js/CoveoJsSearch.Lazy.min.js',
    scriptSearchHash:
      'sha512-0TQxte3BQBFm6LMBjWvy7BSL3OfnzWeZan5bGVd2B/If/9wIYL7ipAWDRtI8HsM08TwP0c6DYnhfy9cOGe56hg==',
    scriptTemplateUrl:
      'https://static.cloud.coveo.com/searchui/v2.10094/3/js/templates/templates.j',
    scriptTemplateHash:
      'sha512-eiSn4qRsVzoRB0c52nRdn8mWn04bANr/LV3rXslk9b+PLN73I6aod28OyEbPTn7iMETKQHlSPESNdosKL/Cp8w==',
    css: 'https://static.cloud.coveo.com/searchui/v2.10094/3/css/CoveoFullSearch.min.css',
    cssHash:
      'sha512-TBs03XI7M4g24z1tWm/81JbvLmC37V35QJxFCayy4NH0yDZ46d/zYlgO9QxLPBu2DmKEsKQxtqfgOU/GfvIRwA==',
    crossOrigin: 'anonymous',
    accessKeyID: 'xxf6d142fb-2bea-4a24-9123-26d2cccb0163',
    organizationId: 'nbcuniversalnonproduction10wz5488n',
    scriptLocale:
      'https://static.cloud.coveo.com/searchui/v2.10094/3/js/cultures/es-es.js',
    scriptLocaleHash:
      'sha512-qFjeMB7hdq+a25Bedf+7iUMML1MhsfdSdng2Te69YmR/et5iIxZlK381Wey234INGujG1xN0oGLo4LdzX5A/7g==',
  },
  production: true,
  resortAreaCode: 'USH',
  resortName: 'USH',
  seoDescription:
    'Welcome to Universal Studios Hollywood! Learn more about our incredible theme park attractions in California such as The Wizarding World of Harry Potter™ and much more!',
  seoImage:
    'https://www.universalorlando.com/tridiondata/k2/en/us/files/Images/universal-orlando-resort-color-logo-b.png',
  seoFacebookSiteName: 'Universal Orlando Resort',
  seoTitle: 'Universal Studios Hollywood - Los Angeles, California',
  seoTwitterSiteName: '@UniversalORL',
  sorryPagePath: '/oops-sorry',
  tridionSite: 'ush',
  tridionBaseUrl: '/tridiondata',
  tripDetailLink: '/web-packages/en/us/shopping-cart/{requestId}',
  uprvUrl:
    'https://res.alpha.universalorlandovacations.com/Booking/Retrieval/Default.aspx?confirmationNo=Reservation_ID&id_token_hint=token_id',
  upsellPackages: 'H572, H573',
  wcsStoreId: '10851',
  webAppPath: 'https://www.universalstudioshollywood.com/web',
  webstoreAppPath: 'https://www.universalorlando.com/web-store',
  webstoreJunction: 'https://universalorlando.com',
  weatherApi: '',
  timeZone: 'America/New_York',
  uniWebServiceApiKey: 'WebApp',
  COMPLETE_AP: 'https://apass-p-st.usj.co.jp/app/top.do',
  commerceApiUrl: 'https://comm-api.universaldestinationsandexperiences.com/',
  commerceClientId: 'mobile_android',
  commerceClientKeyID: 'mBl8RbG6tUU3XYn6PaYssg6Da8vrdPJJW67P4zH9klvXYTiQ8E',
  wtsHostBaseUrl: 'https://store.universalstudioshollywood.com/',
  entitlementBaseUrl: 'https://api.universalparks.com',
  shareQrCodeUrl: '/guest/entitlements/{guestId}/{mediaId}',
  linkEntitlement: '/guests/{guest-id}/link-ticket',
  entitlementDataUrl:
    '/guests/{guestId}/guest-travel-party-member-tickets?resort-area-code={code}&embed=Lineage',
  gtmId: 'GTM-5JHWPZQQ',
  cookieSubDomain: '.universalstudioshollywood.com',
  components: {
    DashboardTicketsComponent: {
      path: '@components/dashboard-tickets-galaxy/dashboard-tickets.component.ts',
    },
  },
  contentApiBaseUrl: 'https://api.universalparks.com',
  contentLoginClientID: 'f1fccd9c-9408-4c34-a425-4793742a4c47',
  contentLoginClientKeyID: 'v6ikIdmNPsTFgnSCwf7b0LGqRDyHhaV4xt3rMKczp18OoXJAje',
  siteName: 'USH',
  contentIdTokenUrl: '/oidc/connect/token',
  pageLabelsUrl: '/resort-areas/ush/content-labels/accounts',
  commerceApi: 'occ/v2/b2cportal_ush',
  crewToolsApi: '',
  rToasterTagId: '',
  isRToasterTagEnabled: false,
  config: {
    createAccount: {
      links: [
        {
          tridionKey: 'createAccount.Terms',
          linkURL: 'createAccount.termsLink',
          target: '_blank',
          altText: 'createAccount.termsAltText',
        },
        {
          tridionKey: 'createAccount.privacyPolicy',
          linkURL: 'createAccount.privacyLink',
          target: '_blank',
          altText: 'createAccount.privacyPolicyAltText',
        },
        {
          tridionKey: 'createAccount.informationcenter',
          linkURL: 'createAccount.infoLink',
          target: '_blank',
          altText: 'createAccount.informationcenterAltText',
        },
      ],
      checkboxes: [
        {
          tridionKey: 'createAccount.agree',
          defaultValue: false,
          required: true,
          id: 'termCondition',
          altText: 'createAccount.agreeAltText',
        },
        {
          tridionKey: 'createAccount.specialOffers',
          defaultValue: true,
          required: false,
          id: 'specialOffer',
          altText: 'createAccount.specialOffersAltText',
        },
      ],
    },
    dashboard: {
      showDiningReservationLink: true,
      showBuyTicketsLink: true,
      showLinkTicketsLink: true,
      showTicketContent: true,
      showCouponCard: false,
      isNavigate: true,
      showLinkTicketType: false,
      showTicketDetailsCta: false,
      matchIconByUrl: true,
    },
    showContentCallout: false,
    showReEnterPassword: false,
    showEntitlementsInfo: false,
    showPriority: true,
    displayFirstNameFirst: true,
    profileTPMDetails: {
      otherMembers: false,
    },
    showShareQr: false,
    deletingUSHAccount: true,
    isV1_1FeatureEnabled: false,
  },
  qrCodeAPIParam: 'textToEncode',
  qrCodeDomainUrl: 'https://www.universalorlando.com',
  qrCodeAPIUrl: '/webdata/CodeGenerator/QRCodeGen/?factor=8',
  isMMDDYYYYFormat: true,
  hideScanIconDesktop: true,
  showPhoneCard: false,
  showCommPrefCard: true,
  showPaymentCard: true,
  showPasswordCard: false,
  showLogoutCard: false,
  showProfileBirthday: false,
  showProfileGender: false,
  showProfileUpdates: false,
  showEdit: false,
  showCreditCardExpDate: false,
  contentIds: {
    GDS_FOOTER_CONTENT_ID: 'GDS-Footer-Utility-USH-ACCOUNT',
    TRIDION_PUBLICATION: 'ush',
    GDS_GLOBAL_NAV_UTILITY_BAR_CONTENT_ID: 'GDS-Main-Nav-Utility-USH-ACCOUNT',
    GDS_GLOBAL_NAV_MEGA_NAV_CONTENT_ID:
      'gds-global-nav-ush-mega-nav-main-account',
  },
  showCreditCardDetails: true,
  subTotalTaxIncluded: false,
  showTaxLabel: false,
  showdeliveryCost: false,
  showTax: true,
  inquiryToken: '',
  oidcInquiryClientId: '',
  oidcInquiryClientKeyID: '',
  taxCodes: {
    display: false,
    NV_LIVE_ENT: '',
    SALES_TAX: '',
  },
  DINING_RESERVATION:
    'https://universalstudioshollywood.com/dining/en/us/dashboard',
  specialOffers: true,
  showGalaxyTickets: true,
  showAlphanumericLinkError: false,
  displayDateByTimezone: true,
  SourceIdKey: {
    en: {
      WebUSJAccountCreation: '1012000',
      WebUSJEditCommunications: '1012004',
      WebUSJEditContactInfo: '1012005',
      WebUSJEditPersonalInfo: '1012006',
      WebUSJEditAddress: '1012007',
      WebUSJCreateorEditProfileTravelParty: '1018004',
      WebUSJLinkEntitlements: '1012029',
      WebUSJAccountDelete: '1032024',
      WebAccountDelete: '1012066',
      WebUpdatePassword: '1012063',
      WebUSHPaymentCard: '1012025',
    },
    ja: {
      WebUSJAccountCreation: '1012000',
      WebUSJEditCommunications: '1012004',
      WebUSJEditContactInfo: '1032005',
      WebUSJEditPersonalInfo: '1012006',
      WebUSJEditAddress: '1012007',
      WebUSJCreateorEditProfileTravelParty: '1012024',
      WebUSJLinkEntitlements: '1012029',
      WebUSJAccountDelete: '1032024',
      WebAccountDelete: '1012066',
      WebUpdatePassword: '1012063',
      WebUSHPaymentCard: '1012025',
    },
  },
  parkInfo: {
    TimeZone: 'America/Los_Angeles',
    abbreviatedMonthDayYearFormat: 'MMM dd, yyyy',
    MonthDayYearFormat: 'MM/dd/yyyy',
  },
  faviconUrl: 'assets/favicons/ush-favicon.ico',
};
